/* eslint-disable */
import Firebase from 'firebase';
import CONSTANT from '../Constant';
import Utils from '../Utils';
import db from '../firebaseInit'

// eslint-disable
export default class UserService {

    constructor(){
        db.firestore.settings({ timestampsInSnapshots: true });
    }
    
    // READ

    static getSettingByKey(key, resolve) {
        if (key) {
            return new Promise((resolve) => {
                db.collection(CONSTANT.COLLECTIONS.APP_SETTINGS).doc(key).get().then((doc) => {
                    if (doc.exists) {
                        resolve(doc.data());
                    } else {
                        console.log("No such document!");
                        resolve(null);
                    }
                })
            })
        } else {
            return new Promise((resolve) => {
                resolve(null);
            });    
        }
    }
}
